import { Box, Input } from "@mui/joy";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import PortalTableLayout from "../components/PortalTableLayout";
import { Util } from "../Helpers/Util";

interface CheckInRecord {
	full_name: string;
	check_in_date: string;
	building_name: string;
}

export default function CheckedInTracker() {
	const [checkIn, setCheckIn] = React.useState<Array<CheckInRecord>>();
	const [nameFilter, setNameFilter] = React.useState("");
	const [bldFilter, setBldFilter] = React.useState("");

	React.useEffect(() => getData(), []);

	const getData = () => {
		fetch("User/GetCheckedInUsers")
			.then((x) => x.json())
			.then((x) => {
				console.log(x);
				setCheckIn(x);
			});
	};

	const rows = checkIn
		?.filter((x) => Util.isNullOrEmpty(nameFilter) || x.full_name.toLowerCase().includes(nameFilter.toLowerCase()))
		.filter((x) => Util.isNullOrEmpty(bldFilter) || x.building_name.toLowerCase().includes(bldFilter.toLowerCase()));

	if (!checkIn) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
				<CircularProgress size={32} />
			</Box>
		);
	}

	return (
		<PortalTableLayout fillHeight={true}>
			<Table stickyHeader size="small">
				<TableHead>
					<TableRow>
						<TableCell>
							<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
								<span>Mechanic</span>
								<Input size="sm" value={nameFilter} onChange={(event) => setNameFilter(event.target.value)} placeholder="Search" />
							</Box>
						</TableCell>
						<TableCell>
							<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
								<span>Building</span>
								<Input size="sm" value={bldFilter} onChange={(event) => setBldFilter(event.target.value)} placeholder="Search" />
							</Box>
						</TableCell>
						<TableCell>Check In/Out Time</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((x, idx) => (
						<TableRow key={`${x.full_name}-${x.building_name}-${x.check_in_date}-${idx}`}>
							<TableCell>{x.full_name}</TableCell>
							<TableCell>{x.building_name}</TableCell>
							<TableCell>{Util.Formatter(x.check_in_date, "DT")}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</PortalTableLayout>
	);
}
